import { useField } from "formik";
import React from "react";
import AppInput from "components/shared/AppInput";

const FormField: React.FC<{
  name: string;
  placeholder?: string;
  type?: string;
  style?: Record<string, string>;
}> = ({ name, placeholder, type, style }) => {
  const [field, meta] = useField(name);

  return (
    <div className="form__fileds">
      <AppInput
        type={type}
        placeholder={placeholder}
        style={style}
        {...field}
      />
      {meta.touched && meta.error ? (
        <div className="error mt-1">
          <p>{meta.error}</p>
        </div>
      ) : null}
    </div>
  );
};

export default FormField;
